<script setup lang="ts">
import type { CmsElementShopSafely } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementShopSafely;
  class: any;
  style: any;
}>();

const {
  heading,
  headingColOne,
  headingColTwo,
  headingColThree,
  ImageCollection_ColOne,
  ImageCollection_ColTwo,
  ImageCollection_ColThree
} = props.content?.config

</script>
<template>
  <section class="section section-main section-logos" :style="props.style" :class="props.class">
    <div class="container">
      <header class="section__head">
        <h2>{{ heading.value }}</h2>
      </header><!-- /.section__head -->

      <div class="section__body">
        <div class="row">
          <div class="col-lg-4">
            <h3>{{ headingColOne.value }}</h3>

            <ul class="list-logos section__list-logos">
              <li v-for="(image, index) in ImageCollection_ColOne.value" :key="index">
                <NuxtImg height="25" style="height:25px" loading="lazy" :src="image?.collectionMedia?.url?.replace(/ /g, '%20')" alt=""></NuxtImg>
              </li>
            </ul><!-- /.list-logos -->
          </div>

          <div class="col-lg-4 footer-row-2">
            <h3>{{ headingColTwo.value }}</h3>

            <ul class="list-logos list-logos--center section__list-logos flex">
              <li v-for="(image, index) in ImageCollection_ColTwo.value"
                  :key="index"
                  class=""
              >
                <NuxtImg
                    :class="{
                  'item-odd': index%2 === 1,
                  'item-even': index%2 === 0,
                    }"
                    format="webp"
                    loading="lazy" :src="image?.collectionMedia?.url?.replace(/ /g, '%20')" width="80" alt=""></NuxtImg>
              </li>
            </ul><!-- /.list-logos -->
          </div>

          <div class="col-lg-4">
            <h3>{{ headingColThree.value }}</h3>

            <ul class="list-logos list-logos--alt list-logos--center section__list-logos">
              <li v-for="(image, index) in ImageCollection_ColThree.value" :key="index">
                <NuxtImg height="25" style="height:25px" format="webp"  loading="lazy" :src="image?.collectionMedia?.url?.replace(/ /g, '%20')" alt=""></NuxtImg>
              </li>
            </ul><!-- /.list-logos -->
          </div>
        </div>
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>